<div class="card-header">
    <h5> {{comparisonResults}} </h5><br>
    <div style="font-weight:bold" [innerHtml]="gasComparisonResultsNote"></div>
</div>
<ng-container *ngIf="!isMobileList">
    <div class="table-wrapper">
        <table class="table-responsive" border=1 frame=void rules=rows>
            <thead>
                <tr>
                    <th scope="col">{{noCrt}}</th>
                    <th scope="col">{{supplier}}</th>
                    <th scope="col">{{offerTypeName}}</th>
                    <th scope="col">{{offerTypedetails}} </th>
                    <th scope="col">{{naturalGasPrice}}</th>
                    <th scope="col">{{shippingCost}}</th>
                    <th scope="col">{{distributionCost}}</th>
                    <th scope="col">{{supplyPriceLeiMwh}}</th>
                    <th scope="col">{{supplyPriceLeiKwh}}</th>
                    <th scope="col">{{cfValue}}</th>
                    <th scope="col">{{comparisonResult}}</th>
                    <th scope="col">{{invoiceValue}}</th>
                    <th scope="col">{{economyCost}}</th>
                    <th scope="col">{{requiredDocuments}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th></th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplier'&& this.sortDirection =='down'}"
                            (click)="onSort(supplier,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplier'&& this.sortDirection =='up'}"
                            (click)="onSort(supplier,'up')"></i>
                    </th>
                    <th></th>
                    <th></th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'naturalGasPrice'&& this.sortDirection =='down'}"
                            (click)="onSort(naturalGasPrice,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'naturalGasPrice'&& this.sortDirection =='up'}"
                            (click)="onSort(naturalGasPrice,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'shippingCost'&& this.sortDirection =='down'}"
                            (click)="onSort(shippingCost,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'shippingCost'&& this.sortDirection =='up'}"
                            (click)="onSort(shippingCost,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'distributionCost'&& this.sortDirection =='down'}"
                            (click)="onSort(distributionCost,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'distributionCost'&& this.sortDirection =='up'}"
                            (click)="onSort(distributionCost,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplyPriceLeiMwh'&& this.sortDirection =='down'}"
                            (click)="onSort(supplyPriceLeiMwh,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplyPriceLeiMwh'&& this.sortDirection =='up'}"
                            (click)="onSort(supplyPriceLeiMwh,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplyPriceLeiKwh'&& this.sortDirection =='down'}"
                            (click)="onSort(supplyPriceLeiKwh,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'supplyPriceLeiKwh'&& this.sortDirection =='up'}"
                            (click)="onSort(supplyPriceLeiKwh,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'cfValue'&& this.sortDirection =='down'}"
                            (click)="onSort(cfValue,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'cfValue'&& this.sortDirection =='up'}"
                            (click)="onSort(cfValue,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'comparisonResult'&& this.sortDirection =='down'}"
                            (click)="onSort(comparisonResult,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'comparisonResult'&& this.sortDirection =='up'}"
                            (click)="onSort(comparisonResult,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'invoiceValue'&& this.sortDirection =='down'}"
                            (click)="onSort(invoiceValue,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'invoiceValue'&& this.sortDirection =='up'}"
                            (click)="onSort(invoiceValue,'up')"></i>
                    </th>
                    <th>
                        <i class="fa fa-sort-down fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'economyCost'&& this.sortDirection =='down'}"
                            (click)="onSort(economyCost,'down')"></i>
                        <i class="fa fa-sort-up fa-2x" [ngClass]="{
                            'selected': this.sortBy == 'economyCost'&& this.sortDirection =='up'}"
                            (click)="onSort(economyCost,'up')"></i>
                    </th>
                    <th></th>
                </tr>
                <ng-container *ngFor="let gasComparatorResult of gasComparatorResults;let i = index">
                    <tr>
                        <td scope="row">{{i+1}}</td>
                        <td><a href="{{gasComparatorResult.url}}" target="_blank" [innerHTML]="gasComparatorResult.nume"></a>
                        </td>
                        <td>
                            <a href="{{gasComparatorResult.url_oferta}}"
                                target="_blank">{{gasComparatorResult.nume_oferta}}</a>
                        </td>
                        <td (click)="onExpandDetails(gasComparatorResult)"><a href="javascript:void(0);"
                                *ngIf="gasComparatorResult.isSubRowDisplayed">{{closeDetails}}</a>
                            <a href="javascript:void(0);"
                                *ngIf="!gasComparatorResult.isSubRowDisplayed">{{viewDetails}}</a>
                        </td>
                        <td>{{gasComparatorResult.pg}}</td>
                        <td>{{gasComparatorResult.tt}}</td>
                        <td>{{gasComparatorResult.t0}}</td>
                        <td class="price bold">
                            <div class="prelative">
                                <span (mouseover)="onMouseOverTvaMwh(tVAPriceTemplateMwh)"
                                    (mouseleave)="onMouseLeaveTvaMwh(tVAPriceTemplateMwh)">
                                    {{onConvertToNumber(gasComparatorResult.pret_furnizare_mwh, 2)}}</span>
                                <div #tVAPriceTemplateMwh class="smallToolTip" style="display: none;">
                                    <b>Valoare cu acciză și TVA:
                                        {{onConvertToNumber(onConvertToNumber(gasComparatorResult.pret_furnizare_mwh) +
                                        onConvertToNumber(gasComparatorResult.acciza) +
                                        (onConvertToNumber(gasComparatorResult.tva) / 100) *
                                        (gasComparatorResult.pg + gasComparatorResult.tt + gasComparatorResult.t0 +
                                        this.onConvertToNumber(this.gasComparatorResult.acciza)), 2)
                                        }}</b>
                                </div>
                            </div>
                        </td>
                        <td class="price bold">
                            <div class="prelative">
                                <span (mouseover)="onMouseOverTvaKwh(tVAPriceTemplateKwh)"
                                    (mouseleave)="onMouseLeaveTvaKwh(tVAPriceTemplateKwh)">
                                    {{onConvertToNumber(gasComparatorResult.pret_furnizare_kwh)}}</span>
                                <div #tVAPriceTemplateKwh class="smallToolTip" style="display: none;">
                                    <b>Valoare cu acciză și TVA:
                                        {{onConvertToNumber((onConvertToNumber(gasComparatorResult.pret_furnizare_mwh) +
                                        onConvertToNumber(gasComparatorResult.acciza) +
                                        (onConvertToNumber(gasComparatorResult.tva) / 100) *
                                        (gasComparatorResult.pg + gasComparatorResult.tt +
                                        gasComparatorResult.t0 +
                                        this.onConvertToNumber(this.gasComparatorResult.acciza))) / 1000, 5)
                                        }}</b>
                                </div>
                            </div>
                        </td>
                        <td><span *ngIf="!gasComparatorResult.cf">0</span>
                            <span *ngIf="gasComparatorResult.cf">{{gasComparatorResult.cf}}</span>
                        </td>
                        <td [ngClass]="{'red': onConvertToNumber(gasComparatorResult.rezultat_comparatie) >= 0 ,
                        'green': onConvertToNumber(gasComparatorResult.rezultat_comparatie) < 0 }">
                            <span class="mandatory"
                                *ngIf="!comparatorForm.controls.supplyPriceLeiMwh.value">{{insertActualprice}}</span>
                            <span *ngIf="comparatorForm.controls.supplyPriceLeiMwh.value">
                                {{onConvertToNumber(gasComparatorResult.rezultat_comparatie)}}%
                                <span *ngIf="onConvertToNumber(gasComparatorResult.rezultat_comparatie) > 0"> ⇑
                                </span>
                                <span *ngIf="onConvertToNumber(gasComparatorResult.rezultat_comparatie) < 0"> ⇓
                                </span>
                            </span>
                        </td>
                        <td>
                            <span class="mandatory"
                                *ngIf="!comparatorForm.controls.estimatedMonthlyConsumptionMwh.value">{{enterEstimatedConsumption}}</span>
                            <span *ngIf="comparatorForm.controls.estimatedMonthlyConsumptionMwh.value">
                                {{onComputeInvoiceValueTvaExcise(gasComparatorResult)}}</span>
                        </td>
                        <td [ngClass]="{'red': onConvertToNumber(gasComparatorResult.economie_sau_cost) >= 0 ,
                        'green': onConvertToNumber(gasComparatorResult.economie_sau_cost) < 0 }">
                            <span class="mandatory"
                                *ngIf="!comparatorForm.controls.estimatedMonthlyConsumptionMwh.value || !comparatorForm.controls.supplyPriceLeiMwh.value">
                                {{enterData}}
                            </span>
                            <span
                                *ngIf="comparatorForm.controls.estimatedMonthlyConsumptionMwh.value && comparatorForm.controls.supplyPriceLeiMwh.value">
                                <span *ngIf="onConvertToNumber(gasComparatorResult.economie_sau_cost) > 0">+
                                </span>{{gasComparatorResult.economie_sau_cost}} lei
                            </span>
                        </td>
                        <td>
                            <a href="javascript:void(0);" (click)="openDocumentsModal(gasComparatorResult)">{{open}}</a>
                        </td>
                        <td *ngIf="isSelectOfferButtonVisible">
                            <a style="cursor:pointer;" class="link" (click)="checkAndSaveOfferToStorage(gasComparatorResult)">{{selectOffer}}</a>
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="gasComparatorResult.isSubRowDisplayed" colspan="15">
                            <app-comparator-gas-result [gasComparatorResult]="gasComparatorResult">
                            </app-comparator-gas-result>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-container>

<ng-container *ngIf="isMobileList">
    <ng-container *ngFor="let gasComparatorResult of gasComparatorResults;let i = index">
        <app-comparator-gas-result [comparatorForm]="comparatorForm" [isMobileView]="true"
            [gasComparatorResult]="gasComparatorResult">
        </app-comparator-gas-result>
    </ng-container>
</ng-container>
